// In-body section heading shared by the rail's Customer and Order info tabs.
// Matches the rail prototype's `.fb-det-h` 1:1 (AI-1424,
// rai-landingpage/option-2 v64): 900 13px/1.2 grey90 with 12px below. The
// 18px top plus RailTabPane's 6px gives the prototype's 24px. `children`
// sit after the title in the same flex row (a pill, a menu, a link).
import { BASE_FONT_FAMILY } from '@thanx/uikit/theme/typography'
import palette from 'constants/palette'
import React from 'react'
import { useStyletron } from 'styletron-react'

const HEADING_PADDING = '18px 0 12px'
const HEADING_GAP = '14px'
const HEADING_FONT_SIZE = '13px'
const HEADING_LINE_HEIGHT = 1.2

type Props = {
  title: string
  children?: React.ReactNode
}

const RailSectionHeading = ({ title, children }: Props) => {
  const [css] = useStyletron()

  return (
    <div
      className={css({
        display: 'flex',
        alignItems: 'center',
        gap: HEADING_GAP,
        padding: HEADING_PADDING,
      })}
    >
      <span
        className={css({
          fontFamily: BASE_FONT_FAMILY,
          fontSize: HEADING_FONT_SIZE,
          fontWeight: 900,
          lineHeight: HEADING_LINE_HEIGHT,
          color: palette.grey90,
        })}
      >
        {title}
      </span>
      {children}
    </div>
  )
}

export default RailSectionHeading
